type ConfigMapDefinitionSource = {
    kind?: string;
    layerName?: string;
};

type ConfigMapDefinitionLastYearsFilter = {
    numberOfYears?: number;
    fieldName?: string;
    pagePrompt?: string;
    filterButtonTitle?: string;
};

type ConfigMapDefinitionTooltip = {
    type?: string;
};

type ConfigMapDefinitionRoadNetwork = {
    enabled?: boolean;
};

export type ConfigMapDefinition = {
    id?: string;
    type?: string;
    title?: string;
    imageIndex?: string;
    url?: string;
    source?: ConfigMapDefinitionSource;
    lastYearsFilter?: ConfigMapDefinitionLastYearsFilter;
    tooltip?: ConfigMapDefinitionTooltip;
    roadNetwork?: ConfigMapDefinitionRoadNetwork;
};

type ConfigMenuEntry = {
    pageId?: string;
    menuSectionPath?: Array<string | number>;
    positionAfter?: string | number;
};

const APP_ROUTE_PREFIX = '/app/';

export function getConfigMapDefinitions(config: any): ConfigMapDefinition[] {
    return Array.isArray(config?.mapDefinitions) ? config.mapDefinitions : [];
}

export function getConfigMapDefinitionById(config: any, definitionId: string) {
    return getConfigMapDefinitions(config).find((definition) => definition?.id === definitionId);
}

export function getRelativeMapRoutePath(url?: string) {
    if (!url || typeof url !== 'string' || !url.startsWith(APP_ROUTE_PREFIX)) return undefined;
    const relativeRoutePath = url.slice(APP_ROUTE_PREFIX.length).replace(/^\/+/, '');
    return relativeRoutePath || undefined;
}

export function getRelativeMapFilterRoutePath(url?: string) {
    const relativeMapRoutePath = getRelativeMapRoutePath(url);
    if (!relativeMapRoutePath) return undefined;
    return `${relativeMapRoutePath}/filters`;
}

export function getConfigMapFilterRouteUrl(url?: string) {
    if (!url || typeof url !== 'string') return undefined;
    return `${url.replace(/\/$/, '')}/filters`;
}

export function getConfiguredMenuEntries(config: any) {
    const definitions = getConfigMapDefinitions(config);
    const definitionsById = new Map(
        definitions
            .filter((definition) => definition?.id)
            .map((definition) => [definition.id as string, definition])
    );
    const menuEntries: ConfigMenuEntry[] = Array.isArray(config?.menuEntries) ? config.menuEntries : [];

    return menuEntries.map((entry) => {
        const definition = entry?.pageId ? definitionsById.get(entry.pageId) : undefined;
        if (!definition?.title || !definition?.url) return undefined;

        return {
            menuSectionPath: entry?.menuSectionPath,
            positionAfter: entry?.positionAfter,
            item: {
                type: definition?.type ?? `map.${definition?.id}`,
                title: definition?.title,
                imageIndex: definition?.imageIndex,
                url: definition?.url,
            }
        };
    }).filter((item) => item);
}
